import Util from "../util";

export const setupPageModals = function () {
	function initPageModal(modal, modalOpen, modalClose) {

		document.querySelectorAll(modalOpen).forEach((item) => {
			item.addEventListener("click", function (event) {
								
				if(item.dataset !== undefined && item.dataset.modalClose === 'true') {
					closePageModal();
				}
				Util.addClass(modal, "js-add-transform");

				setTimeout(function () {
					Util.addClass(modal, "js-is-visible");
				}, 250);

				// TODO: Add events tracking
				Util.removeClass(document.querySelector(".js-drawer"), "drawer--is-visible");

				// Fix body class
				const scrollY = document.documentElement.style.getPropertyValue("--scroll-y");
				const body = document.body;
				body.style.position = "fixed";
				body.style.top = `-${scrollY}`;

				// Set modal position
				modal.style.top = scrollY;
				modal.style.bottom = `-${scrollY}`;
			});
		});

		modalClose.addEventListener("click", function (event) {
			// Close Modal
			const body = document.body;
			const scrollY = body.style.top;
			body.style.position = "";
			body.style.top = "";

			modal.style.top = 0;
			modal.style.bottom = 0;

			window.scrollTo(0, parseInt(scrollY || "0") * -1);

			Util.removeClass(modal, "js-is-visible");
			
			setTimeout(function () {
				Util.removeClass(modal, "js-add-transform");
			}, 100);
		});
	}

	const collectionsModal = document.getElementsByClassName("js-collections-modal");
	const collectionsModalOpen = ".js-collections-modal-open";
	const collectionsModalClose = document.querySelector(".js-collections-modal-close");

	if (collectionsModal.length > 0) {
		for (var i = 0; i < collectionsModal.length; i++) {
			(function (i) {
				initPageModal(collectionsModal[i], collectionsModalOpen, collectionsModalClose);
			})(i);
		}
	}

	const fabricSwatchModal = document.getElementsByClassName("js-fabric-swatch-modal");
	const fabricSwatchModalOpen = ".js-fabric-swatch-modal-open";
	const fabricSwatchModalClose = document.querySelector(".js-fabric-swatch-modal-close");

	if (fabricSwatchModal.length > 0) {
		for (var i = 0; i < fabricSwatchModal.length; i++) {
			(function (i) {
				initPageModal(fabricSwatchModal[i], fabricSwatchModalOpen, fabricSwatchModalClose);
			})(i);
		}
	}

	const pdfFormModal = document.getElementsByClassName("js-pdf-form-modal");
	const pdfFormModalOpen = ".js-pdf-form-modal-open";
	const pdfFormModalClose = document.querySelector(".js-pdf-form-modal-close");

	if (pdfFormModal.length > 0) {
		for (var i = 0; i < pdfFormModal.length; i++) {
			(function (i) {
				initPageModal(pdfFormModal[i], pdfFormModalOpen, pdfFormModalClose);
			})(i);
		}
	}

	window.addEventListener("scroll", () => {
		document.documentElement.style.setProperty("--scroll-y", `${window.scrollY}px`);
	});
};

export const closePageModal = function () {
	document.querySelectorAll(".page-modal").forEach((item) => {
		Util.removeClass(item, "js-is-visible");
	});

	const body = document.body;

	body.style.position = "";
	body.style.top = "";
};
